(function ($) {
    var o = $({});

    $.subscribe = function (event, handler) {
        o.on(event, handler);
    };

    $.unsubscribe = function (event, handler) {
        o.off(event, handler);
    };

    $.publish = function (event, data) {
        o.trigger(event, data);
    };
}(window.jQuery));